import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface UserDirectoryEntry {
  id: number;
  fullName: string;
  email: string;
  roleNames: string[];
  teamId: number;
}

@Injectable({
  providedIn: 'root'
})
export class UserDirectoryService {

  constructor(
    private http: ApiHttpClient
  ) { }

  getUserDirectoryEntries(): Observable<any> {
      return this.http.get(`${environment.API_URL}/user-directory`);
  }
}
